import { jsx as _jsx } from "react/jsx-runtime";
/** Small bordered label, e.g. the ATO code next to a category. */
export function Tag({ children }) {
    return _jsx("span", { style: { fontSize: 11, color: 'var(--text-3)', border: '1px solid var(--border)', padding: '0 4px', borderRadius: 2, flex: 'none', lineHeight: 1.6 }, children: children });
}
//# sourceMappingURL=Tag.js.map